var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCurrencyPound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 19.8V17h-7v-3.7h5.3v-2.4h-5.3v-.6C10.8 8 12 7 13.6 7c.9 0 1.7.3 2.3.9l2-2.1c-1.1-1.1-2.6-1.6-4.3-1.6-3.2 0-5.8 2-5.8 6.1v.7H6.1v2.4h1.8v3.7H6.1v2.8h11.7z"
  })));
}

export default SvgCurrencyPound;